package content

import BaseLayoutStyles
import kotlinReactComponents.sprintChart
import react.Props
import react.dom.html.ReactHTML.br
import react.dom.html.ReactHTML.li
import react.fc
import styled.*



    val optimizingOfDevelopmentProcessContent =  fc<Props>("OptimizingOfDevelopmentProcessContent") {
    styledH1 {
        css {

        }
        +"Optimierung der Softwareentwicklung"
    }
    styledH3 {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        +"Sehen die Burn-Down-Charts ihrer Sprints manchmal so aus?"
        styledDiv {
            css {
                +BaseLayoutStyles.alignContentAtCenter
                +BaseLayoutStyles.alignItemsCenter
                +BaseLayoutStyles.alignSelfCenter
                +BaseLayoutStyles.alignTextCenter
                +BaseLayoutStyles.marginHorizontalAuto
            }


//            val fullDataRealSprint = arrayOf(63, 61, 54, 48, 40, 40, 40, 50, 42, 38, 33, 30, 25, 20)
//            sprintChart (fullDataRealSprint)
            sprintChart()
        }

    }
    styledH3 {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        styledBr{}
        styledP {
            +"Treten bei Ihnen immer wieder Bugs auf?"
        }
        styledP {
            +"Gibt es instabile Zustände ihrer Programme?"
        }
        styledP{
        +"Wird die Implementierung neuer Features immer langsamer?"
        }
        styledP{
        +"Oder haben Ihre Programme Performanceprobleme?"
        }
        styledBr{}
        styledP {
            +"Dann sollten Sie Ihren Entwicklungsprozess überprüfen!"
        }

    }

    styledH3 {
        css {
            +BaseLayoutStyles.alignTextCenter
        }
        styledBr{}
        styledP {
            +"Wir helfen Ihnen gerne."
        }
        styledBr{}
    }
    styledH3 {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        +"Bei der Optimierung der Softwareentwicklung gehen wir wie folgt vor:"
    }
    styledP {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        +"Zunächst machen wir eine Bestandsaufnahme und untersuchen wie die Entwicklung durchgeführt wird. "
    }
    styledP {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        +"Dabei betrachten wir unter anderem folgende Fragestellungen: "
    }
    styledUl {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        li {
            +"Wie wird entschieden was entwickelt wird?"
        }
        li {
            +"Wie genau/kleinteilig ist die Planung?"
        }
        li {
            +"Wie wird entschieden, wie genau/kleinteilig die Planung sein sollte?"
        }
        li {
            +"Wie wird überprüft, wie ob ein Entwicklungsschritt das erreicht, was er erreichen sollte?"
        }

        li {
            +"Wie sind die Verantwortlichkeiten verteilt?"
        }
        li {
            +"Gibt es Kompetenzüberschneidungen? "
            br {}
            +"- Wenn ja, wie sind sie entstanden und worauf beruhen sie?"
        }
        li {
            +"Wann und wie werden die Wünsche der Kunden ermittelt?"
        }
        li {
            +"Wie geht die Zufriedenheit der Kunden/Nutzer in den Entwicklungsprozess mit ein?"
        }
        li {
            +"Wie werden die einzelnen Entwicklungsschritte bestimmt?"
        }
        li {
            +"Wie werden die einzelnen Aufgaben verteilt?"
        }
        li {
            +"Wie wird entschieden, ob eine Teilentwicklung den Anforderungen entspricht?"
        }
        li {
            +"Wie sieht der Prozess vom Schreiben einer Zeile Code bis zum Release aus?"
        }
        li {
            +"Wie wird die Qualitätssicherung durchgeführt?"
        }
        li {
            +"Wie ist der Code strukturiert?"
        }
        li {
            +"Gibt es Spaghetti-, Ravioli- oder Lasagne - Code?"
        }
        li {
            +"Werden etablierte Architekturmuster verwendet?"
        }
        li {
            +"Werden Dinge mehrfach entwickelt?"
        }
        li {
            +"Gibt es Doppelungen im Code?"
        }
    }

    styledP {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        +"Abhängig von den Ergebnissen werden Problemfelder identifiziert und beschrieben. "
        styledBr{}
        +"Anschließend werden mögliche Maßnahmen zur Beseitigung der Probleme entwickelt und vorgestellt."
    }
    styledP {
        css {
            +BaseLayoutStyles.alignTextLeft
        }
        +"Bei der Umsetzung der Maßnahmen unterstützen und begleiten wir sie gerne. "
        styledBr{}
        +"Bei Bedarf auch mit Schulungen und Workshops."
    }
}
